'use strict';

var GridElipsisDropdownDirective = function GridElipsisDropdownDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    transclude: true,
    template: require('../templates/grid-elipsis-dropdown.html')
  };
};
GridElipsisDropdownDirective.$inject = [];
module.exports = GridElipsisDropdownDirective;